import { ButtonBase, InputAdornment, Typography } from '@material-ui/core';
import { ArrowDropDown, ArrowDropUp } from '@material-ui/icons';
import { makeStyles } from '@material-ui/styles';
import { ColorDynamic } from '@superdispatch/ui';
import { forwardRef, useMemo } from 'react';
import { formatCountry, getCountryCode } from "../country-code-metadata/CountryCodeMetadata.js";
import { PhoneFieldFlag } from "./PhoneFieldFlag.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = /*#__PURE__*/makeStyles(theme => ({
  root: {
    marginLeft: theme.spacing(-1),
    marginRight: 0
  },
  button: {
    color: ColorDynamic.Blue300,
    padding: theme.spacing(0.5, 0.5, 0.5, 1),
    borderRadius: theme.spacing(0.5, 0, 0, 0.5),
    '&:hover, &:focus': {
      backgroundColor: ColorDynamic.Blue50
    }
  }
}), {
  name: 'SD-PhoneFieldStartAdornment'
});
export var PhoneFieldStartAdornment = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
    country,
    onClick,
    isExpanded,
    disabled
  } = _ref;
  var styles = useStyles();
  var [title, countryCode] = useMemo(() => {
    var code = "+".concat(getCountryCode(country));
    return ["".concat(formatCountry(country), ": ").concat(code), code];
  }, [country]);
  return /*#__PURE__*/_jsx(InputAdornment, {
    ref: ref,
    position: "start",
    className: styles.root,
    children: /*#__PURE__*/_jsxs(ButtonBase, {
      title: title,
      onClick: onClick,
      className: styles.button,
      "aria-expanded": isExpanded,
      disabled: disabled,
      children: [/*#__PURE__*/_jsx(PhoneFieldFlag, {
        country: country
      }), isExpanded ? /*#__PURE__*/_jsx(ArrowDropUp, {
        htmlColor: disabled ? ColorDynamic.Dark100 : ColorDynamic.Dark200
      }) : /*#__PURE__*/_jsx(ArrowDropDown, {
        htmlColor: disabled ? ColorDynamic.Dark100 : ColorDynamic.Dark200
      }), /*#__PURE__*/_jsx(Typography, {
        children: /*#__PURE__*/_jsx("span", {
          style: {
            color: disabled ? ColorDynamic.Dark100 : ColorDynamic.Dark500
          },
          children: countryCode
        })
      })]
    })
  });
});
if (process.env.NODE_ENV !== "production") PhoneFieldStartAdornment.displayName = "PhoneFieldStartAdornment";